import { FooterSection } from './FooterSection';
const meta = {
    title: 'Features/AIChatWidget/FooterSection',
    component: FooterSection
};
export default meta;
export const Default = {
    args: {
        onSendMessage: (message, attachments) => {
            console.log('Message sent:', message, attachments);
        },
        isDisabled: false,
        isLoading: false
    }
};
export const Loading = {
    args: {
        onSendMessage: (message, attachments) => {
            console.log('Message sent:', message, attachments);
        },
        isDisabled: false,
        isLoading: true
    }
};
export const Disabled = {
    args: {
        onSendMessage: (message, attachments) => {
            console.log('Message sent:', message, attachments);
        },
        isDisabled: true,
        isLoading: false
    }
};
